import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/route-patterns'

const URL_ADMIN_ACCOUNT_MANAGEMENT_BULK = `${URL_APP_ADMIN}/account-management-bulk`
// Editor + detail routes (requirements §4). These live at top-level admin paths rather
// than under the wrapper above: IPP nests a router's children under the wrapper's path
// prefix, and §4 mandates these exact URLs (the Sparse 6 "Open in Bulk Editor" deep-link
// contract depends on them), so each is registered as its own top-level admin route.
const URL_ADMIN_BULK_OVERVIEW = `${URL_APP_ADMIN}/bulk`
const URL_ADMIN_BULK_USERS = `${URL_APP_ADMIN}/users/bulk`
const URL_ADMIN_BULK_ROLES = `${URL_APP_ADMIN}/roles/bulk`
const URL_ADMIN_BULK_OPERATIONS_DETAIL = `${URL_APP_ADMIN}/bulk/operations/:operationId`
// Sparse 6 routes. `/admin/bulk/operations` must be registered *before* the `:operationId`
// detail route in the switch so the list isn't shadowed by the param route.
const URL_ADMIN_BULK_OPERATIONS = `${URL_APP_ADMIN}/bulk/operations`
const URL_ADMIN_BULK_APPROVALS = `${URL_APP_ADMIN}/bulk/approvals`
const URL_ADMIN_BULK_AUDIT = `${URL_APP_ADMIN}/bulk/audit`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-account-management-bulk'>
  | DashRouteType<'app-admin-account-management-bulk-overview'>
  | DashRouteType<'app-admin-account-management-bulk-users'>
  | DashRouteType<'app-admin-account-management-bulk-roles'>
  | DashRouteType<'app-admin-account-management-bulk-operations-detail', { operationId: string }>
  | DashRouteType<'app-admin-account-management-bulk-operations'>
  | DashRouteType<'app-admin-account-management-bulk-approvals'>
  | DashRouteType<'app-admin-account-management-bulk-audit'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-account-management-bulk': URL_ADMIN_ACCOUNT_MANAGEMENT_BULK,
  'app-admin-account-management-bulk-overview': URL_ADMIN_BULK_OVERVIEW,
  'app-admin-account-management-bulk-users': URL_ADMIN_BULK_USERS,
  'app-admin-account-management-bulk-roles': URL_ADMIN_BULK_ROLES,
  'app-admin-account-management-bulk-operations-detail': URL_ADMIN_BULK_OPERATIONS_DETAIL,
  'app-admin-account-management-bulk-operations': URL_ADMIN_BULK_OPERATIONS,
  'app-admin-account-management-bulk-approvals': URL_ADMIN_BULK_APPROVALS,
  'app-admin-account-management-bulk-audit': URL_ADMIN_BULK_AUDIT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
